module.exports = __webpack_public_path__ + "img/node-minus-fill.564fab4f.svg";